export default __webpack_public_path__ + "static/media/grafema_recta-intencao-book_04.2be141b6.jpg";